import { render, staticRenderFns } from "./ModalPreview.vue?vue&type=template&id=0c0884a4&scoped=true&"
import script from "./ModalPreview.vue?vue&type=script&lang=js&"
export * from "./ModalPreview.vue?vue&type=script&lang=js&"
import style0 from "./ModalPreview.vue?vue&type=style&index=0&id=0c0884a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0884a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c0884a4')) {
      api.createRecord('0c0884a4', component.options)
    } else {
      api.reload('0c0884a4', component.options)
    }
    module.hot.accept("./ModalPreview.vue?vue&type=template&id=0c0884a4&scoped=true&", function () {
      api.rerender('0c0884a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/ModalPreview.vue"
export default component.exports